import React from 'react'
import { CommentSection as CommentSectionComponent } from '../../../components'

const postData = {
  title: 'Boardgame for Peace',
  comments: [
    {
      user: {
        name: 'Marin'
      },
      date: 'July 24, 2020 at 2:42 am',
      text: 'Apakah informasi ini bisa saya sebar di platform lain seperti WhatsApp?'
    }
  ]
}

const CommentSection = ({title}) => {
  const data = postData

  if(title){
    data.title = title
  }

  return (
    <div className="w-full lg:w-7/12">
      <CommentSectionComponent
        post={data}
        comments={data.comments}
      />
    </div>
  )
}

export { CommentSection }
